import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const DeleteIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path d="M3 6h18" stroke={color} strokeWidth={strokeWidth} fill="none" />
      <path d="M8 6V4h8v2" stroke={color} strokeWidth={strokeWidth} fill="none" />
      <path d="M19 6l-1 14H6L5 6" stroke={color} strokeWidth={strokeWidth} fill="none" />
    </BaseIcon>
  ),
);

DeleteIcon.displayName = 'DeleteIcon';
